import { render, staticRenderFns } from "./FireArms.vue?vue&type=template&id=3d74735e"
import script from "./FireArms.vue?vue&type=script&lang=js"
export * from "./FireArms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports